<template>
  <div>
    <el-table :data="tableData" stripe style="width: 100%" border="">
      <el-table-column prop="gmtCreate" label="账单日" width="180"></el-table-column>
      <el-table-column prop="orderAmountText" label="账单金额" width="180"></el-table-column>
      <el-table-column prop="billPayedAmountText" label="已还金额">
        <template slot-scope="props">0</template>
      </el-table-column>
      <el-table-column prop="orderAmount" label="未还金额"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="props">
          <el-button
            size="mini"
            type="text"
            @click="$router.push({name:'distributor-credit-back-running'})"
          >查看明细</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: "NotBillTable",
  data() {
    return {};
  },
  props: ["tableData"]
};
</script>
<style lang="less" scoped>
.el-button {
  border-radius: 0;
}
</style>